import jsPDF from 'jspdf'

function Invoice() {
    const orderDetails = {
        customerName: "Иван Иванов",
        customerAddress: "Улица 123, Град",
        customerEmail: "ivan@mail.com",
        invoiceNumber: "F123456",
        date: "2025-02-13",
        products: [
            { name: "Продукт 1", price: 500, quantity: 2 },
            { name: "Продукт 2", price: 300, quantity: 1 },
            { name: "Продукт 3", price: 700, quantity: 3 },
        ],
        total: 3500
    };

    const generateInvoicePDF = () => {
        const doc = new jsPDF();

        doc.addFont('assets/Roboto-Regular.ttf', 'roboto', 'regular'); // Замени го 'path_to_roboto_font.ttf' со патеката до твојот фонт

        // Поставување на фонтот
        doc.setFont("roboto", "regular");

        // Set encoding for non-Latin characters (Macedonian Cyrillic in your case)
        doc.setFontSize(16);
        doc.text("Име на компанијата: XYZ Ltd.", 20, 20);

        // Client details
        doc.setFontSize(12);
        doc.text(`Клиент: ${orderDetails.customerName}`, 20, 30);
        doc.text(`Адреса: ${orderDetails.customerAddress}`, 20, 40);
        doc.text(`Е-маил: ${orderDetails.customerEmail}`, 20, 50);

        // Invoice details
        doc.text(`Број на фактура: ${orderDetails.invoiceNumber}`, 150, 30);
        doc.text(`Датум: ${orderDetails.date}`, 150, 40);

        // Table headers
        doc.setFontSize(12);
        doc.text("Продукт", 20, 70);
        doc.text("Цена", 120, 70);
        doc.text("Количина", 150, 70);
        doc.text("Вкупно", 180, 70);

        let yOffset = 80; // Starting point for table rows

        // Loop through products and add them to the table
        orderDetails.products.forEach((product, index) => {
            doc.text(product.name, 20, yOffset);
            doc.text(product.price.toString(), 120, yOffset);
            doc.text(product.quantity.toString(), 150, yOffset);
            doc.text((product.price * product.quantity).toString(), 180, yOffset);
            yOffset += 10;
        });

        // Total amount
        
        doc.text(`Вкупен износ: ${orderDetails.total} ден`, 20, yOffset + 10);

        // Save PDF
        doc.save('invoice.pdf');
    }


    return (
        <div>
            <button onClick={() => generateInvoicePDF(orderDetails)}>Klikni</button>
        </div>
    )
}

export default Invoice
